import React, { useContext } from "react";
import { Card, Grid, Typography} from "@mui/material";
// const educ = [
//   {course: 'Bachelor of Engineering', inst: 'Panjab University', special: 'Information Technology', startdate: '04/01/2016',enddate : '05/20/2020', "grade" : '8.2'},
//   {course: 'Class 12th', inst: 'ABC School', special: 'Non-Med', startdate: '04/01/2015',enddate : '05/20/2016', grade : '8.2'},
//   {course: 'Class 10th', inst: 'ABC School', special: 'Science', startdate: '04/01/2013',enddate : '05/20/2014', grade : '8.2'}
  
// ]


function EducationComponent({edu}) {
  console.log(edu)
  return (
      
    <div>
    <Card>
        <Grid container>
      {edu?.map((item)=>
       <Grid item lg={6} xs={12}>
       <Card sx={{padding:'2%',backgroundColor:'#f3f5fb',margin:'8%'}}>
      <Typography Typography sx={{fontFamily:'poppins',fontSize:'20px',fontWeight:'500',marginTop:'4%'}}> {item.course} at {item.inst} </Typography>
      <Typography sx={{fontFamily:'poppins',fontSize:'16px',fontWeight:'200',marginTop:'4%'}}>
        {item.start} - {item.end}
      </Typography>
      <Typography sx={{fontFamily:'poppins',fontSize:'16px',fontWeight:'200',marginTop:'4%'}}>{item.special}</Typography>
      <Typography sx={{fontFamily:'poppins',fontSize:'16px',fontWeight:'200',marginTop:'4%'}}>{item.grade}</Typography>
      </Card></Grid>
      )}</Grid></Card>
    </div>
  );
}
export default EducationComponent;
